"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_LEDGER_BALANCE_STATE = exports.Currency = exports.TransactionHistoryList = exports.RESET_STATE = exports.GET_TRANSACTION_HISTORY = exports.GET_ACTIVITIES_HISTORY = exports.REDEEM_FROM_POINTS = exports.USER_BALANCE_EXPIRY = exports.USER_BALANCE = exports.USER_TOKENS = void 0;
const TransactionHistoryList_1 = require("./TransactionHistoryList");
Object.defineProperty(exports, "TransactionHistoryList", { enumerable: true, get: function () { return TransactionHistoryList_1.TransactionHistoryList; } });
var Currency;
(function (Currency) {
    Currency["TOKENS"] = "TOKENS";
    Currency["LOYALTY_POINTS"] = "LOYALTY_POINTS";
})(Currency || (exports.Currency = Currency = {}));
const USER_TOKENS = 'ledger/USER_TOKENS';
exports.USER_TOKENS = USER_TOKENS;
const USER_BALANCE = 'ledger/USER_BALANCE';
exports.USER_BALANCE = USER_BALANCE;
const USER_BALANCE_EXPIRY = 'ledger/USER_BALANCE_EXPIRY';
exports.USER_BALANCE_EXPIRY = USER_BALANCE_EXPIRY;
const REDEEM_FROM_POINTS = 'ledger/REDEEM_FROM_POINTS';
exports.REDEEM_FROM_POINTS = REDEEM_FROM_POINTS;
const GET_TRANSACTION_HISTORY = 'ledger/GET_TRANSACTION_HISTORY';
exports.GET_TRANSACTION_HISTORY = GET_TRANSACTION_HISTORY;
const GET_ACTIVITIES_HISTORY = 'ledger/GET_ACTIVITIES_HISTORY';
exports.GET_ACTIVITIES_HISTORY = GET_ACTIVITIES_HISTORY;
const RESET_STATE = 'ledger/RESET_STATE';
exports.RESET_STATE = RESET_STATE;
const RESET_LEDGER_BALANCE_STATE = 'ledger/RESET_LEDGER_BALANCE_STATE';
exports.RESET_LEDGER_BALANCE_STATE = RESET_LEDGER_BALANCE_STATE;
//# sourceMappingURL=types.js.map